import React from "react";
import { ResponsiveDeviceType } from "../../../widget/layouts/ScreenMedia";
import Scaffold from "../../../widget/layouts/Scaffold";
import { MainBodyContainer } from "../../../widget/common/ui/MainContainer";
import AppTranslation from "../../../service/app_translation/AppTranslation";
import DeactivateAccountReasonContent from "./widget/DeactivateAccountReasonContent";
import DeactivateAccountReasonButtons from "./widget/DeactivateAccountReasonButtons";
import { DeactivateAccountContextProvider } from "../../../provider/deactivate_account/DeactivateAccountContextProvider";

const DeactivateAccountReasonScreen = () => {
  const type: number = ResponsiveDeviceType();

  return (
    <DeactivateAccountContextProvider>
      <Scaffold
        appBarTitle={AppTranslation.text("deactivate_account")}
        bottomNavigationButton={<DeactivateAccountReasonButtons />}
      >
        <MainBodyContainer className="py-5">
          <DeactivateAccountReasonContent type={type} />
        </MainBodyContainer>
      </Scaffold>
    </DeactivateAccountContextProvider>
  );
};

export default DeactivateAccountReasonScreen;
export const routeName: string = "/settings/deactivate-account-reason";
